import { v4 as uuid } from 'uuid';
// Constants
import { WhatsappConstants } from './WhatsappConstants';
export class WhatsAppService {
    static $inject = ['MessagingHubService', 'ConfigurationsService', 'BlipToastService', 'SegmentService', '$translate'];
    constructor(MessagingHubService, ConfigurationsService, BlipToastService, SegmentService, $translate) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.ConfigurationsService = ConfigurationsService;
        this.BlipToastService = BlipToastService;
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.saveConfigurationComponentAndCreateTracking = async (application, event, eventTracking, configuration, trackingPayload) => {
            let isSuccess = false;
            if (!event) {
                return isSuccess;
            }
            const actionSwitch = event.detail.checked ? 'connect' : 'disconnect';
            try {
                await this.setConfiguration(configuration);
                isSuccess = true;
                this.BlipToastService.show('success', {
                    msg: await this.$translate('whatsapp.successMsg.saveConfigurations.msg'),
                });
            }
            catch (e) {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('whatsapp.errorMsg.saveConfigurations.title'),
                    msg: await this.$translate('whatsapp.errorMsg.saveConfigurations.msg'),
                });
            }
            let payload = { action: actionSwitch, success: isSuccess };
            payload = { ...trackingPayload, ...payload };
            await this.createTrackingFlow(application, eventTracking, payload);
            return isSuccess;
        };
    }
    setConfiguration(configuration, useConfigurationsApplication = false) {
        return this.ConfigurationsService.set(WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY, configuration, undefined, useConfigurationsApplication);
    }
    async getWabas(userAccessToken) {
        const uri = `${WhatsappConstants.WABAS_WITH_FILTERS_URI}${userAccessToken}`;
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: uri,
        });
        const { resource: { items } } = await this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return items;
    }
    async getProfile() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: WhatsappConstants.PROFILE_URI,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getPhoneNumberDetails() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: WhatsappConstants.PHONE_NUMBER_DETAILS_URI,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async setProfile(profile) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: WhatsappConstants.PROFILE_URI,
            type: WhatsappConstants.PROFILE_RESOURCE_TYPE,
            resource: profile,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getWabaDetails() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: WhatsappConstants.WABAS_DETAILS_URI,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getBusinessDetails() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: WhatsappConstants.BUSINESS_DETAILS_URI,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async setStateConfigurations(phoneNumberId, whatsappBusinessAccountId, currentUserEmail, pin, subsidiary, skipValidateTicket, isCoexistenceEnabled, isCloudApiEnabled) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: WhatsappConstants.STATE_CONFIGURATIONS_URI,
            type: WhatsappConstants.DEFAULT_RESOURCE_TYPE,
            resource: {
                IsChannelActive: true,
                PhoneNumberId: phoneNumberId,
                WhatsappBusinessAccountId: whatsappBusinessAccountId,
                WhatsappBusinessAccountCurrencyCode: WhatsappConstants.CURRENCY_CODE,
                CurrentUserEmail: currentUserEmail,
                IsCloudApiEnabled: isCloudApiEnabled,
                Pin: pin,
                Subsidiary: subsidiary,
                ShouldValidateTicket: !skipValidateTicket,
                IsCoexistenceEnabled: isCoexistenceEnabled,
            },
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
    async subscribeToContainerConfiguration() {
        const commandResponse = await this.MessagingHubService.processCommand({
            id: uuid(),
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'subscribe',
            uri: WhatsappConstants.CONTAINER_CONFIGURATION_URI,
        });
        return this.MessagingHubService.ensureCommandSuccess(commandResponse);
    }
    async clientHasBalanceToConnectToWhatsapp() {
        return await this.getPaymentAccountWhatsAppNumbersBalance() > 0;
    }
    async getPaymentAccountWhatsAppNumbersBalance() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: WhatsappConstants.NUMBERS_BALANCE_URI,
        });
        const { resource } = await this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return Number(resource).valueOf();
    }
    async createTrackingFlow(application, event, payload) {
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: { ...payload },
        });
    }
    async getMessageTemplateInsights(templateName) {
        const commandResponse = await this.MessagingHubService.processCommand({
            id: uuid(),
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: `${WhatsappConstants.MESSAGE_TEMPLATE_INSIGHTS}?templateName=${templateName}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getAdsInsights(adId, since, until) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: `${WhatsappConstants.INSIGHTS}/${adId}/ads?since=${since}&until=${until}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource.data[0];
    }
}
WhatsAppService.$inject = ['MessagingHubService', 'ConfigurationsService', 'BlipToastService', 'SegmentService', '$translate'];
